import { Request } from '../../index'

export type SubsidyOrdersSumsParams = {
  schoolId: string
}

export type SubsidyOrdersSum = number | string

type ApiParams = {
  school_id: number
}

type ApiResult = SubsidyOrdersSum[]

export const convertParams = ({
  schoolId,
}: SubsidyOrdersSumsParams): [ApiParams, null] => [
  { school_id: Number(schoolId) },
  null,
]

export const convertResult = (apiData: ApiResult): SubsidyOrdersSum[] => apiData || []

export const GET_SCHOOL_SUBSIDY_ORDERS_SUMS: Request<
  SubsidyOrdersSumsParams,
  SubsidyOrdersSum[],
  void
> = ['reports/school_subsidy_orders_sums', 'get', ['data', 'sums']]
